export default __webpack_public_path__ + "static/media/phase2.afddf610.png";